export default __webpack_public_path__ + "static/tte-2-8df79d2a0724700894a24173c6dae6b3.png";